module.exports = __webpack_public_path__ + "static/media/ic-tab-explore.31592156.png";